import { render, staticRenderFns } from "./StudentMenu.vue?vue&type=template&id=98240a6a"
import script from "./StudentMenu.vue?vue&type=script&lang=js"
export * from "./StudentMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports